module.exports = __webpack_public_path__ + "img/advancedStringInverter.3387f935.svg";